import React, { ReactNode } from 'react';
import styles from './DragAndDropWrapper.module.scss';

interface IDraggableItemProps {
    children: ReactNode;
    id: string;
}

const DraggableItem: React.FC<IDraggableItemProps> = (props: IDraggableItemProps) => (
    <div id={props.id} className={styles.dragAndDrop_draggable_item}>
        {props.children}
    </div>
);

export default DraggableItem;
